<div style="margin-top: 12px">
  <div *ngIf="mainTable?.headers?.length">
    <div #scrollDiv class="scrollable-table">
      <table>
        <thead>
          <tr>
            <th colspan="2">&nbsp;</th>
            <ng-container *ngFor="let h of mainTable.headers; let i = index">
              <th nowrap="nowrap" *ngIf="!isHidden(i)">{{ h.text }}</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let s of mainTable.sections">
            <tr *ngIf="s.rows.length">
              <th colspan="2" class="section-break">{{ s.name }}</th>
              <ng-container *ngFor="let h of mainTable.headers; let i = index">
                <th class="section-break" *ngIf="!isHidden(i)">{{ h.text }}</th>
              </ng-container>
            </tr>

            <tr *ngFor="let r of s.rows">
              <th>{{ r.legacyId }}</th>
              <th>{{ r.header }}</th>
              <ng-container *ngFor="let v of r.values; let i = index">
                <td *ngIf="!isHidden(i)">
                  <span class="link-class" (click)="gotoQuestion(v)">
                    {{ v?.answer }}
                  </span>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
